import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import type { ContextFamily, ContextTone } from '@quipex/shared/utils';
import { Loader } from '../loader/loader';

@Component({
    selector: 'qpx-loading-icon[matButtonIcon]',
    imports: [Loader],
    template: `
        <qpx-loader
            [context]="context()"
            [tone]="tone()"
            containerClass=""
            [size]="size()"
        />
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'flex items-center justify-center mat-icon',
    },
})
export class LoadingIcon {
    public readonly size = input<'sm' | 'md' | 'lg'>('sm');
    public readonly context = input<ContextFamily>();
    public readonly tone = input<ContextTone>('default');
}
